import React from "react";
import { Outlet, NavLink, useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, CalendarCheck, Bike, MapPin, Package, Tag, Star, Users, LogOut, Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const links = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Tableau de bord" },
  { to: "/admin/bookings", icon: CalendarCheck, label: "Réservations" },
  { to: "/admin/fleet", icon: Bike, label: "Parc / Stock" },
  { to: "/admin/cities", icon: MapPin, label: "Villes & Zones" },
  { to: "/admin/catalog", icon: Package, label: "Matériel & Tarifs" },
  { to: "/admin/customers", icon: Users, label: "Clients" },
  { to: "/admin/promos", icon: Tag, label: "Codes promo" },
  { to: "/admin/reviews", icon: Star, label: "Avis" },
];

const AdminLayout = () => {
  const { user, ready, logout } = useAuth();
  const navigate = useNavigate();
  if (!ready) return <div className="min-h-screen grid place-items-center"><Loader2 className="w-10 h-10 animate-spin text-brand" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen flex bg-cream">
      <aside className="w-64 bg-ink text-slate-300 flex flex-col shrink-0 sticky top-0 h-screen">
        <div className="p-6 flex items-center gap-2 border-b border-white/10">
          <span className="w-10 h-10 rounded-2xl bg-white text-brand grid place-items-center font-heading font-extrabold text-lg">M</span>
          <span className="font-heading font-extrabold text-xl text-white">MobiRider</span>
        </div>
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.to.split("/").pop() || "dashboard"}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-xl font-semibold text-base transition-colors ${isActive ? "bg-brand text-white" : "hover:bg-white/5"}`}>
              <l.icon className="w-5 h-5" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={() => { logout(); navigate("/admin/login"); }} data-testid="admin-logout" className="m-4 flex items-center gap-3 px-4 py-3 rounded-xl font-semibold hover:bg-white/5">
          <LogOut className="w-5 h-5" /> Déconnexion
        </button>
      </aside>
      <main className="flex-1 p-6 md:p-10 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
